import { render, staticRenderFns } from "./MigrationBlock.vue?vue&type=template&id=75a7b8fd&scoped=true"
import script from "./MigrationBlock.vue?vue&type=script&lang=ts"
export * from "./MigrationBlock.vue?vue&type=script&lang=ts"
import style0 from "./MigrationBlock.vue?vue&type=style&index=0&id=75a7b8fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a7b8fd",
  null
  
)

export default component.exports